module.exports = __webpack_public_path__ + "static/media/didiao001.ab8d2a21.jpg";